import { render } from "./App.vue?vue&type=template&id=f8e8c78c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f8e8c78c&lang=css"

import exportComponent from "/home/vsts/work/1/s/ReftabHelperWww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__